/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoggedInHeader from './LoggedInHeader';
import LoggedOutHeader from './LoggedOutHeader';

const NewHeader = ({ ...props }) => {
  const {
    hasAuthCreds, hasCompletedWalkthrough, showSignUp, cable,
  } = props;

  if (hasAuthCreds === null || (hasAuthCreds && !hasCompletedWalkthrough)) return null;

  return (
    <div className="new-header">
      {hasAuthCreds ? <LoggedInHeader cable={cable} /> : <LoggedOutHeader showSignUp={showSignUp} />}
    </div>
  );
};

NewHeader.propTypes = {
  hasAuthCreds: PropTypes.bool,
  hasCompletedWalkthrough: PropTypes.bool.isRequired,
  showSignUp: PropTypes.bool,
  cable: PropTypes.shape({
    subscriptions: PropTypes.shape({
      create: PropTypes.func.isRequired,
    }).isRequired,
  }),
};

NewHeader.defaultProps = {
  hasAuthCreds: false,
  showSignUp: true,
  cable: null,
};

export default connect((state) => ({
  hasAuthCreds: state.auth.hasAuthCreds,
  hasCompletedWalkthrough: state.auth.hasCompletedWalkthrough,
}))(withRouter(NewHeader));
